import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap';
import './styles/deleteModal.scss';

function DeleteModal(props) {

  const { show, text } = props;
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show) {
      setInput('');
      setLoading(false);
    }
  }, [show]);

  const handleClose = () => {
    if (!loading) props.onClose();
  };

  const handleDelete = () => {
    setLoading(true);
    props.onDelete();
  };

  return (
    <div>
      <Modal className="delete-modal-component" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body className="delete-modal-content">
          <Alert variant="warning">
            Vas a eliminar <strong>{text}.</strong><br />
            Para confirmar esta acción escribe la palabra <strong>ELIMINAR.</strong><br />
            Recuerda que esta acción no se puede deshacer.
          </Alert>
          <Form.Control
            type="text"
            value={input}
            onChange={event => setInput(event.target.value)}
          />
          <div className="options">
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="danger" disabled={input !== 'ELIMINAR' || loading} onClick={handleDelete}>
              {
                loading ? <Spinner size="sm" variant="warning" animation="border" /> : 'Eliminar'
              }
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default DeleteModal;
